import { render, staticRenderFns } from "./ResourcePager.vue?vue&type=template&id=167293b7&"
import script from "./ResourcePager.vue?vue&type=script&lang=js&"
export * from "./ResourcePager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports